/**
 * @generated SignedSource<<7a94b5d3c40f1b612a63585552f32f13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyOverviewTab_organization$data = {
  readonly activeJobs: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly jobPosting: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"JobPostingCard_jobPosting">;
        } | null;
      };
    }>;
  };
  readonly carouselReviews: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly author: {
          readonly id: string;
        };
        readonly createdAt: ContraAPIScalars.DateTime;
        readonly id: string;
        readonly reviewText: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"CompanyReviewCard_userReview">;
      };
    }>;
  };
  readonly name: string;
  readonly publicMembers: {
    readonly count: number;
  };
  readonly slug: string | null;
  readonly visitorIsMember: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"AverageCompanyReviewScoreBreakdown_organization" | "CompanyPeopleList_organization" | "OverviewIndyEmptyState_organization" | "OverviewJobSectionEmptyState_organization" | "OverviewRecommendationsSectionEmptyState_organization" | "OverviewTeamSectionEmptyState_organization">;
  readonly " $fragmentType": "CompanyOverviewTab_organization";
};
export type CompanyOverviewTab_organization$key = {
  readonly " $data"?: CompanyOverviewTab_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyOverviewTab_organization">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "publicMembersFirst"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanyOverviewTab_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompanyPeopleList_organization"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorIsMember",
      "storageKey": null
    },
    {
      "alias": "activeJobs",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "statuses": [
              "POSTED"
            ]
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        }
      ],
      "concreteType": "OrganizationJobConnection",
      "kind": "LinkedField",
      "name": "jobs",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationJobEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Job",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JobPosting",
                  "kind": "LinkedField",
                  "name": "jobPosting",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobPostingCard_jobPosting"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "jobs(filter:{\"statuses\":[\"POSTED\"]},first:2)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "publicMembersFirst"
        }
      ],
      "concreteType": "PublicOrganizationMemberConnection",
      "kind": "LinkedField",
      "name": "publicMembers",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "carouselReviews",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "hideEmptyReviews": true
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 5
        }
      ],
      "concreteType": "UserReviewConnection",
      "kind": "LinkedField",
      "name": "userReviews",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "UserReviewEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UserReview",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserProfile",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "reviewText",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CompanyReviewCard_userReview"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userReviews(filter:{\"hideEmptyReviews\":true},first:5)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AverageCompanyReviewScoreBreakdown_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OverviewJobSectionEmptyState_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OverviewRecommendationsSectionEmptyState_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OverviewTeamSectionEmptyState_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OverviewIndyEmptyState_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "223e4b7055cc102a1709c95d5eb0adb7";

export default node;
